import React, { Component } from "react";
import { func, shape, bool, string, number, arrayOf } from "prop-types";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import Col from "react-bootstrap/lib/Col";
import { Form, withFormik } from "formik";
import { compose } from "redux";

import I18n from "pages/_components/I18n";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";
import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";
import Heading from "pages/_components/Heading";
import { selectors as debinSelectors, actions as debinActions } from "reducers/debin";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import PageLoading from "pages/_components/PageLoading";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import Notification from "pages/_components/Notification";
import { resizableRoute } from "pages/_components/Resizable";
import classNames from "classnames";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

class ChargebackPullConfirm extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        debinDetail: shape({}).isRequired,
        loggedUser: shape({
            accessToken: string,
            defaultAvatarId: string,
            email: string,
            previousLoginInfo: arrayOf(
                shape({
                    city: string,
                    country: string,
                    date: string,
                    idUser: string,
                    ip: string,
                    latitude: number,
                    longitude: number,
                }),
            ),
            securitySeal: number,
            userFullName: string,
        }),
        accounts: shape({}),
        fetchingAccounts: bool.isRequired,
        // accountName: string.isRequired,
        isSubmitting: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
        loggedUser: null,
        accounts: null,
    };

    componentDidMount() {
        const { dispatch, loggedUser, accounts, debinDetail } = this.props;

        if (!accounts.length > 0) {
            dispatch(accountsActions.listAccounts(loggedUser.userId));
        }

        if (!debinDetail) {
            dispatch(goBack());
        }
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, debinDetail } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                prevProps.debinDetail?.id !== debinDetail?.id)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop, debinDetail } = this.props;
        if (!debinDetail?.id) {
            return;
        }
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["debin"],
            titleKey: "payments.debin.chargebackPull.header.title",
            goBackPath: `/payments/payDebin/detail/${debinDetail.id}`,
        });
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    };

    handleClose = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    };

    getTitle = () => {
        const { isDesktop } = this.props;

        if (isDesktop) {
            return (
                <>
                    <div className="view-title data-wrapper-flex">
                        <h1 className="my-0 mr-3">{i18nUtils.get("payments.debin.chargebackPull.header.title")}</h1>
                    </div>
                    <p className="my-1">{i18nUtils.get("payments.debin.chargebackPull.header.subtitle")}</p>
                </>
            );
        }

        return (
            <div className="title-account-header-multiline-background-blue">
                <h1>{i18nUtils.get("payments.debin.chargebackPull.header.title")}</h1>
            </div>
        );
    };

    render() {
        const { isDesktop, fetchingAccounts, debinDetail, isSubmitting, embeddedInV3Shell } = this.props;

        if (!debinDetail) {
            return <></>;
        }

        const continueButton = (
            <Col className="col col-12" lg={12} xl={12} md={12} sm={12}>
                <Button
                    type="submit"
                    bsStyle="primary"
                    label="global.confirm"
                    image="images/arrowRight.svg"
                    imageStyle="mr-2"
                    loading={isSubmitting}
                />
            </Col>
        );

        const {
            concept,
            description,
            expirationDate,
            sellerDetail,
            amount: { currency, quantity },
            amount,
            reference,
            idVoucher,
            creationDate,
        } = debinDetail;

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="decline-debin" />}
                {!(embeddedInV3Shell && !isDesktop) && (
                    <div className="admin-detail-head px-0">
                        <Head
                            onBack={this.handleBack}
                            onClose={isDesktop && this.handleClose}
                            headerClassName={classNames({
                                "blue-main-header-mobile": !isDesktop,
                            })}
                            centerElement={!isDesktop && this.getTitle}
                            emptyRightOption
                        />
                        {isDesktop && (
                            <Head
                                centerElement={this.getTitle}
                                centerContentClassName="d-flex flex-column align-items-start"
                            />
                        )}
                    </div>
                )}
                <PageLoading loading={fetchingAccounts}>
                    <MainContainer>
                        <Form className="above-the-fold">
                            {!isDesktop && (
                                <div className="admin-content-center d-flex justify-content-center">
                                    <I18n
                                        id="payments.debin.chargebackPull.header.subtitle"
                                        component="h2"
                                        componentProps={{ className: "py-3 px-4 f-size-35" }}
                                    />
                                </div>
                            )}
                            <Container
                                className="flex-grow container-white my-2 with-padding"
                                style={{ textTransform: "uppercase" }}>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label="payments.debin.detail.table.header.amount"
                                        data={
                                            amount ? (
                                                <FormattedAmount
                                                    currency={currency}
                                                    quantity={quantity}
                                                    notBold="true"
                                                />
                                            ) : (
                                                "-"
                                            )
                                        }
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label="payments.debin.detail.table.header.concept"
                                        data={concept ? i18nUtils.get(`transfers.concept.${concept}`) : "-"}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label="payments.debin.detail.table.header.description"
                                        data={description || "-"}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label="payments.debin.detail.table.header.expirationDate"
                                        data={
                                            expirationDate ? (
                                                <FormattedDate date={expirationDate} dateFormat="dd/MM/yyyy" showTime />
                                            ) : (
                                                "-"
                                            )
                                        }
                                    />
                                </Col>
                            </Container>
                            <Container
                                className="flex-grow container-white my-2 with-padding"
                                style={{ textTransform: "uppercase" }}>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label="payments.debin.detail.table.header.voucher"
                                        data={idVoucher || "-"}
                                    />
                                </Col>

                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label="payments.debin.detail.table.header.sender"
                                        data={sellerDetail.titular || "-"}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label="payments.debin.detail.table.header.documentType"
                                        data={
                                            (
                                                <div>
                                                    <span style={{ marginRight: "0.5rem" }}>
                                                        {sellerDetail.documentType}
                                                    </span>
                                                    <span>{sellerDetail.documentNumber}</span>
                                                </div>
                                            ) || "-"
                                        }
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label="payments.debin.detail.table.header.creationDate"
                                        data={
                                            creationDate ? (
                                                <FormattedDate date={creationDate} dateFormat="dd/MM/yyyy" showTime />
                                            ) : (
                                                "-"
                                            )
                                        }
                                    />
                                </Col>
                            </Container>
                            <Container
                                className="flex-grow container-white my-2 with-padding"
                                style={{ textTransform: "uppercase" }}>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label={`payments.debin.detail.table.header.${(() => {
                                            const isCVU = sellerDetail?.cbu?.startsWith("000");
                                            return isCVU ? "chargeback.cvu" : "chargeback.cbu";
                                        })()}`}
                                        data={sellerDetail.cbu || "-"}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label="payments.debin.detail.table.header.alias"
                                        data={sellerDetail.cbuAlias || "-"}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label={`payments.debin.detail.table.header.${
                                            sellerDetail?.cbu?.startsWith("000") ? "entity" : "branch"
                                        }`}
                                        data={(() => {
                                            if (!sellerDetail.bank) {
                                                return "-";
                                            }
                                            if (sellerDetail.cbu.startsWith("000")) {
                                                return sellerDetail.bank;
                                            }
                                            return `${sellerDetail.bank} / ${sellerDetail.branch}`;
                                        })()}
                                    />
                                </Col>
                                <Col className="col col-12" md={3} xl={3} lg={3} sm={12}>
                                    <Heading.DataGroup
                                        containerClassName={`transfer-data ${
                                            !isDesktop
                                                ? "data-wrapper-flex space-between mb-0 debin-detail"
                                                : "data-wrapper"
                                        }`}
                                        label="payments.debin.detail.table.header.reference"
                                        data={reference || "-"}
                                    />
                                </Col>
                            </Container>
                            <Container className="flex-grow align-items-center pt-5 pb-2" gridClassName="form-content">
                                <Col className="col col-12 col-xl-4" sm={12} md={10} lg={6}>
                                    {continueButton}
                                </Col>
                            </Container>
                        </Form>
                    </MainContainer>
                </PageLoading>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    debinDetail: debinSelectors.getDebinDetail(state),
    accountName: debinSelectors.getAccountName(state),
    chargebackPullReason: debinSelectors.getChargebackPullReason(state),
    loggedUser: sessionSelectors.getUser(state),
    fetchingAccounts: accountsSelectors.getFetching(state),
    accounts: accountsSelectors.getAccounts(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({}),
        handleSubmit: (values, formikBag) => {
            const { dispatch, debinDetail, chargebackPullReason } = formikBag.props;
            const reason = chargebackPullReason || "";
            const { id: idDebin, amount } = debinDetail;

            dispatch(
                debinActions.chargebackPullIncomingRequestSend(
                    amount.currency,
                    amount,
                    idDebin,
                    reason,
                    formikBag,
                    debinDetail,
                ),
            );
        },
    }),
    resizableRoute,
)(ChargebackPullConfirm);
